import z from 'zod'

import { SUPPORTED_COUNTRIES } from '@/common/constants/countries'
import { LANGUAGES } from '../constants/languages'

export const accountModel = z.object({
  __typename: z.literal('Account').default('Account'),
  id: z.string(),
  accountKey: z.string(),
  locale: z.enum(LANGUAGES),
  country: z.enum(SUPPORTED_COUNTRIES),
  title: z.string(),
  description: z.string().nullable(),
  flag: z.string().nullable(),
  metadata: z.record(z.string()),
  isActive: z.boolean(),
})

export type AccountModel = z.infer<typeof accountModel>
